import { Messages } from '../../../../codegen/Localize';
import { RunFlowTaskInfo } from '../../../../ts/models/RunFlowTaskInfo';
import { runFlowTaskResume } from '../../../actions/spaces/RunFlowTaskMenuActions';
import { AppState } from '../../../state/AppState';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const RunFlowTaskResumeAction: IEntityAction<RunFlowTaskInfo, {}> = {
  name: EntityActionNames.TasksResume,
  translateName: Messages.runFlowTasksResumeAction,
  isVisible: (targetItems: RunFlowTaskInfo[], state: AppState) => {
    return targetItems.length > 0;
  },
  isClickable: (_availableActions: {}, targetItems: RunFlowTaskInfo[]) => {
    const singleSuspendedItem = targetItems.length === 1 && targetItems[0].suspended;
    return targetItems.length !== 1 || singleSuspendedItem;
  },
  createReduxAction: (targetItems: RunFlowTaskInfo[]) => runFlowTaskResume(targetItems)
};
